import { DivIcon, Util, Marker } from "leaflet";
import { MapHtml } from "../map-html";
import { ContactPlace } from "../../../core/models";

export class ContactMarkerBuilder {
  static buildMarker(place: ContactPlace): Marker {
    let iconSettings = { mapIconUrl: MapHtml.getContactPlaceIcon() };

    let divIcon = new DivIcon({
      className: "no",
      html: Util.template(iconSettings.mapIconUrl, iconSettings),
      iconAnchor: [12, 12],
      iconSize: [25, 25],
      popupAnchor: [0, -12]
    });

    const options = { id: place.id, icon: divIcon };
    const marker = new Marker([place.lat, place.lon], options);

    marker.bindPopup(MapHtml.getContactPopup(place), { closeButton: false });

    return marker;
  }
}
